import ReactModal from "react-modal";
import { BoxModal } from "../boxModal";
import { banco_codigo } from "../../assets/banco_codigo";

import { FaBarcode, FaBank, FaKey, FaUser, FaMoneyBillWave } from 'react-icons/fa';
import { BsBank2 } from "react-icons/bs";
import moment from "moment";
import { apiV1 } from "../../lib/axios";
import { toast } from "react-toastify";
import { useState } from "react";

export function PendingTransactionModal({ isOpen, onClose, transaction, fetchPendingTransactions }) {
  const [loading, setLoading] = useState(false);
  const handleUpdateTransaction = async (transactionId, action) => {
    try {
      setLoading(true);
      await apiV1.put(`/transactions/${transactionId}/${action}`);
      fetchPendingTransactions();
      const message = action === 'approve' ? 'Transação aprovada com sucesso!' : 'Transação recusada com sucesso!';
      toast.success(message);
    } catch (error) {
      console.error('Erro ao atualizar transação:', error);
      toast.error(error?.response?.data?.message || 'Erro ao atualizar transação. Tente novamente.');
    } finally {
      setLoading(false);
      onClose();
    }
  };

  const getBankName = (bankCode) => {
    return banco_codigo.find((item) => item.value === bankCode)?.label;
  };

  const renderTransactionDetails = () => {
    if (!transaction) return null;

    switch (transaction.type) {
      case 'BOLETO':
        return (
          <>
            <div className="detail-item">
              <FaBarcode className="icon" />
              <div className="d-flex flex-column align-items-start">
                <span>Código de Barras:</span>
                <span>{transaction.payload?.data.barcode}</span>
              </div>
            </div>
            <div className="detail-item">
              <FaMoneyBillWave className="icon" />
              <div className="d-flex flex-column align-items-start">
                <span>Vencimento:</span>
                <span>{moment(transaction.payload?.data.dueDate).format('DD/MM/YYYY')}</span>
              </div>
            </div>
            <div className="detail-item">
              <FaUser className="icon" />
              <div className="d-flex flex-column align-items-start">
                <span>Nome do favorecido: </span>
                <span>{transaction.payload?.dbData?.receiverName}</span>
              </div>
            </div>
          </>
        );

      case 'PIX':
      case 'ECHECK':
        return (
          <>
            <div className="detail-item">
              <FaKey className="icon" />
              <div className="d-flex flex-column align-items-start">
                <span>Chave: </span>
                <span>{transaction.payload?.pixKey || transaction.payload?.data?.pixKey}</span>
              </div>
            </div>
            <div className="detail-item">
              <FaUser className="icon" />
              <div className="d-flex flex-column align-items-start">
                <span>Nome do favorecido: </span>
                <span>{transaction.payload?.dbData?.receiverName}</span>
              </div>
            </div>
            <div className="detail-item">
              <BsBank2 className="icon" />
              <div className="d-flex flex-column align-items-start">
                <span>Instituição: </span>
                <span>{getBankName(transaction.payload?.dbData?.receiverBank)}</span>
              </div>
            </div>
          </>
        );

      case 'TED':
        return (
          <>
            <div className="detail-item">
              <FaUser className="icon" />
              <div className="d-flex flex-column align-items-start">
                <span>Nome do favorecido: </span>
                <span>{transaction.payload?.data.toName}</span>
              </div>
            </div>
            <div className="detail-item">
              <BsBank2 className="icon" />
              <div className="d-flex flex-column align-items-start">
                <span>Instituição do favorecido: </span>
                <span>{getBankName(transaction.payload?.data.bank)}</span>
              </div>
            </div>
          </>
        );

      default:
        return <div className="detail-item">Tipo de transação não reconhecido.</div>;
    }
  };

  const renderStatusBadge = (status) => {
    let className = '';
    switch (status) {
      case 'Aprovado': className = 'badge-success'; break;
      case 'Rejeitado': className = 'badge-danger'; break;
      case 'Pendente': default: className = 'badge-warning'; break;
    }
    return <span className={`status-badge ${className}`}>{status}</span>;
  };

  return (
    <ReactModal isOpen={isOpen} className="change-modal" overlayClassName="overlay-change-password-modal">
      <BoxModal title="Detalhes da Transação" maxWidth={600} close={onClose}>
        <div className="modal-content p-4">
          <section className="section-general mb-4">
            <h5>Dados Gerais</h5>
            <div className="detail-item">
              <FaMoneyBillWave className="icon" />
              <span>Tipo de Transação: </span>
              <span>{transaction?.type}</span>
            </div>
            <div className="detail-item">
              <FaMoneyBillWave className="icon" />
              <span>Data de Criação: </span>
              <span>{moment(transaction?.createdAt).format('DD/MM/YYYY HH:mm:ss')}</span>
            </div>
            <div className="detail-item">
              <FaMoneyBillWave className="icon" />
              <span>Valor: </span>
              <span>{Number(transaction?.value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
            </div>
            <div className="detail-item">
              <FaMoneyBillWave className="icon" />
              <span>Nome do acesso que realizou: </span>
              <span>{transaction?.createdByCompanyUser?.name}</span>
            </div>
            <div className="detail-item">
              <FaMoneyBillWave className="icon" />
              <span>Status: </span>
              <span>{renderStatusBadge(transaction?.status)}</span>
            </div>
          </section>

          <section className="section-details mb-4">
            <h5>Detalhes da Transação</h5>
            {renderTransactionDetails()}
          </section>

          {transaction?.status === 'Pendente' && (
            <div className="transactions-action-buttons d-flex justify-content-between">
              <button
                className="btn btn-success w-45"
                onClick={() => !loading && handleUpdateTransaction(transaction?.id, 'approve')}
                disabled={loading}
              >
                {loading ? 'Aguarde...' : 'Aprovar'}
              </button>
              <button
                className="btn btn-danger w-45"
                onClick={() => !loading && handleUpdateTransaction(transaction?.id, 'reject')}
                disabled={loading}
              >
                {loading ? 'Aguarde...' : 'Rejeitar'}
              </button>
            </div>
          )}
        </div>
      </BoxModal>
    </ReactModal>
  );
}
